import React from 'react'
import PropTypes from 'prop-types'
import configureStore from '../../shared/configure_store'
import managers from '../reducers/settings/managers'
import { GlobalProvider } from '../../shared/global_context'
import GgGolfHubSettingsComponent from './gg_golf_hub_settings_component'

const GgGolfHubSettingsRoot = (initialState) => {
  const state = {
    managers: initialState.managers,
    customerLeagueId: initialState.customerLeagueId,
    customerId: initialState.customerId,
    urls: initialState.urls || {},
  }
  const store = configureStore(managers, state)
  return (
    <GlobalProvider store={store}>
      <GgGolfHubSettingsComponent />
    </GlobalProvider>
  )
}

GgGolfHubSettingsRoot.propTypes = {
  managers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    email: PropTypes.string,
    status: PropTypes.bool,
    canDelete: PropTypes.bool,
  })),
  customerLeagueId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  customerId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
}

export default GgGolfHubSettingsRoot
